export const RFP_DATE_RANGE_INFO =
  'The date range selected here will be the timeframe when the RFP and resulting contracts and routing guides will be active and running.';

export const REFETCH_ON_SCROLL_HEIGHT = 40;
